export default "__VITE_ASSET__DdwoLll4__"